import React from 'react';
import shortid from 'shortid';

import { Title } from 'components/typography';
import ProductCard from './ProductCard';

import { products as productItems } from './Products.constants';
import { products, summary, productCards } from './scss/Products.module.scss';

const Products = () => (
  <div className={products}>
    <div className={summary}>
      <Title value="AFEX products" size="xl" />
      <p>
        The products and services leading the way to a future where Africa feeds
        itself. Explore our wide variety of products and services below.
      </p>
    </div>
    <div className={productCards}>
      {productItems.map(item => (
        <ProductCard key={shortid()} {...item} />
      ))}
    </div>
  </div>
);

export default Products;
